import { IUpdateNotificationsStatus } from '../../page/page-storage/notifications/notifications.types';
import { IMeetingSimple } from '../../resource/meeting-simple/meeting-simple.types';
import { INotification, INotificationSearchParams } from '../../resource/notification/notification.types';
import { IUser } from '../../resource/user/user.types';
import { IApiRequestConfig } from '../api.types';

export const searchNotificationsApi = (params?: INotificationSearchParams): IApiRequestConfig => ({
  apiRouteKey: 'searchNotifications',
  uri: 'json',
  action: 'notifications',
  method: 'get',
  params: {
    ...params,
  },
  v2: true,
});

export const updateNotificationApi = (notificationId: INotification['id']): IApiRequestConfig => ({
  apiRouteKey: 'updateNotification',
  uri: 'json',
  action: 'updateNotifications',
  method: 'put',
  params: {
    id: notificationId,
  },
});

export const updateNotificationsApi = (notificationIds: INotification['id'][]): IApiRequestConfig => ({
  apiRouteKey: 'updateNotifications',
  uri: 'json',
  action: 'updateNotifications',
  method: 'put',
  data: {
    notificationIds,
  },
});

export const updateNotificationsStatusApi = (payload: IUpdateNotificationsStatus['payload']): IApiRequestConfig => ({
  apiRouteKey: 'updateNotifications',
  uri: 'json',
  action: 'notifications/change-status',
  method: 'patch',
  data: payload,
  v2: true,
});

export const sendMessageToMeetingMembersApi = (payload: {
  sender_id: IUser['id'];
  receiver_ids: IUser['id'][];
  meeting_id: IMeetingSimple['id'];
  message: string;
  type: string;
}): IApiRequestConfig => ({
  apiRouteKey: 'sendMessageToMeetingMembers',
  uri: 'json',
  action: 'notifications/send-message',
  method: 'post',
  data: payload,
  v2: true,
});
